"use strict";

module.exports = /* @ngInject */ function($sce) {
  return function(url) {
    return $sce.trustAsResourceUrl(url);
  };
};



// WEBPACK FOOTER //
// ./app/presentation/filters/trustAsResourceUrl.js